// customerIdSlice.js
import {createSlice} from '@reduxjs/toolkit';

const customerIdSlice = createSlice({
  name: 'customerIdValue',
  initialState: {
    customerId: null,
    loanAccountNo: null,
  },
  reducers: {
    setCustomerIdValue: (state, action) => {
      state.customerId = action.payload;
    },
    clearCustomerIdValue: state => {
      state.customerId = null;
    },
    setLoanAccountNo: (state, action) => {
      state.loanAccountNo = action.payload;
    },
    clearLoanAccountNo: state => {
      state.loanAccountNo = null;
    },
  },
});

export const {
  setCustomerIdValue,
  clearCustomerIdValue,
  setLoanAccountNo,
  clearLoanAccountNo,
} = customerIdSlice.actions;
export default customerIdSlice.reducer;
